module.exports = __webpack_public_path__ + "static/img/img(37).94876a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(37).png
// module id = 0hzS
// module chunks = 1